.row {
  &[data-selected='true'] {
    border: 1px solid var(--color-primary-crayola, #367bff);
    background: rgba(54, 123, 255, 0.3);

    & td {
      border-top: 1px solid var(--color-primary-crayola, #367bff);
      border-bottom: 1px solid var(--color-primary-crayola, #367bff);

      &:first-child {
        border-left: 1px solid var(--color-primary-crayola, #367bff);
      }

      &:last-child {
        border-right: 1px solid var(--color-primary-crayola, #367bff);
      }
    }
  }
}

.last-cell-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4.8rem;
}

.delete-button {
  color: #db5c66;
  svg path {
    fill: #db5c66;
  }
}

.uploading-container {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  justify-content: flex-end;
}

.upload-progress {
  color: var(--color-grayscale-manatee, #959bab);
  font-size: 14px;
  font-weight: 400;
}

.list-item-circular-progress-indicator {
  height: 3.2rem;
  width: 3.2rem;
}

.folder-image {
  max-width: 2.5rem;
  max-height: 100%;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}
